/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveSessionInput } from '../../models/live-session-input';
import { LiveSessionUpsert } from '../../models/live-session-upsert';

export interface ApiLiveSessionPost$Params {
  publish?: boolean;
      body: LiveSessionInput
}

export function apiLiveSessionPost(http: HttpClient, rootUrl: string, params: ApiLiveSessionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionUpsert>> {
  const rb = new RequestBuilder(rootUrl, apiLiveSessionPost.PATH, 'post');
  if (params) {
    rb.query('publish', params.publish, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveSessionUpsert>;
    })
  );
}

apiLiveSessionPost.PATH = '/api/live_session';
